import {AxiosInstance} from "axios";
import FileUrl from "@/core/interfaces/FileUrl";

export interface ConsumerCartResponse {
    data: ConsumerCart[];
    meta: {
        after_key?: string;
    }
}

export interface ConsumerCart {
    key: string;
    date: string;
    has_prescription: true;
    prescription_urls: FileUrl[][] | null;
    type: 'prescription' | 'parapharmacy';
    quantity: number;
    revenue: number;
    margin: number;
    professional: {
        id: number | null;
        code: string | null;
        name: string | null;
        profession: string | null;
        speciality: string | null;
    };
    operator: {
        name: string | null;
    };
    products: {
        id: string;
        name: string;
        code: string | null;
        quantity: number;
        revenue: number;
    }[];
}

export interface ConsumerCartRequest {
    /** The prescriptors rpps to filter the cart by. */
    doctors?: number[];
}

export default function (hdsClient: AxiosInstance) {
    return {
        /**
         * Index carts for the consumer.
         *
         * @returns {Promise<Object>}
         */
        async index(consumerKey: string, afterKey?: string | null, query: ConsumerCartRequest = {}, controller?: AbortController): Promise<ConsumerCartResponse> {
            const params: { limit: number, after_key?: string } = {
                limit: 5,
                ...query
            };

            if (afterKey) {
                params.after_key = JSON.stringify(afterKey);
            }

            return hdsClient.get(`/consumers/${consumerKey}/carts`, {
                params: params,
                signal: controller?.signal
            })
                .then(response => response.data);
        }
    };
}
